<template>
  <div class="card flex-row">
    <div class="flex-column">      
      <div class="ac-text-header">
        {{ `${contact.firstName} ${contact.lastName}` }}
      </div>
      <div class="ac-text-body">
        {{ contact.title }}
      </div>
      <div class="flex-row mb-2">
        <div class="sac__font-16">
          {{ contact.phone }}
        </div>
        <div v-if="contact.email" class="sac__font-16 ml-4">
          {{ contact.email }}
        </div>
      </div>
      <div v-if="contact.isPrimary" class="sac__font-16 bold flex align-center">
        Primary Contact
        <v-icon medium color="black" class="ml-1 mb-1">
          mdi-star-outline
        </v-icon>
      </div>
    </div>
    <div v-if="adminRole === 'admin'" class="ac-row-container">
      <button @click="toggleActionModal(true, 'edit-contact', contact)">
        <v-icon color="#4471F1" medium>
          mdi-pencil-outline
        </v-icon>
      </button>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

export default {
  name: 'PartnerContact',
  mixins: [partnerSettingsMixin],
  props: {
    contact: Object,
    toggleActionModal: Function,
  },
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 1rem;
  font-weight: 700;
  color: $N80;
}

.sub-header {
  font-size: 1rem;
  font-weight: 500;
  color: $N60;
}

.card {
  border-radius: 6px;
  border: 1px solid #C4C5CC;
  padding: 8px 12px;
  width: fit-content;
  flex-wrap: wrap;
  margin: 8px;
}

.ac-text-wrapper {
  max-height: 700px;
  flex-wrap: wrap;
  display: flex;
  overflow-y: auto;
}

.ac-text-header {
  font-size: 18px;
  font-weight: 600;
}

.ac-text-body {
  font-size: 18px;
  font-weight: 400;
  color: $N60;
}

.ac-row-container {
  height: fit-content;
  margin-left: 25px;
  margin-right: 5px;
  display: flex;
}

.ac-button {
  padding: 6px 24px;
  border-radius: 6px;
  color: $WHITE;
  font-weight: 600;
  font-size: 1rem;

  &:first-child {
    background-color: $NBLUE100;
    margin-right: 8px;
  }

  &:last-child {
    background-color: $TOMATO100;
  }
}
</style>